import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
// import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

const FooterDiv = () => {
  const classes = useStyles();
  const preventDefault = (event) => event.preventDefault();
  
  return (
    <React.Fragment>
      <CssBaseline />
      <Container style={{ backgroundColor: "#cfe8fc", height: "50px" }}>
        <Grid container direction="row" justify="center" alignItems="center" style={{height: "50px" }}>
          {/* <Typography align="center" component="div" variant="subtitle2">
          </Typography> */}
          <Grid item xs={6}></Grid>
          <Grid item xs={2}>© 語楽フットボール</Grid>
          <Grid item xs={2}>
            <Typography className={classes.root}>
                <Button size="small" color="primary" href="https://football-sns.net/language/privacy/" target="_blank" to="/url">
                  プライバシーポリシー
              </Button>
            </Typography>            
          </Grid>
          <Grid item xs={2}>
            <Typography className={classes.root}>
                <Button size="small" color="primary" href="https://football-sns.net/language/about/" target="_blank" to="/url">
                  サイトについて
              </Button>
            </Typography>            

            </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default FooterDiv;
